import React from "react";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { FormControlLabel, Checkbox } from "@mui/material";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const useStyles = makeStyles(customInputStyle);

export default function CoverageSelection({
  form,
  handleChange,
  agentTypes = [],
  buttonsSave
}) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.consumersite || false}
              onChange={handleChange}
              name="consumersite"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Allow Consumer Site User (HDI)"
        />
      </GridItem>
      <GridItem xs={12} sm={6}></GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratepd || false}
              onChange={handleChange}
              name="ratepd"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate PD"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratemedical || false}
              onChange={handleChange}
              name="ratemedical"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Medical"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratetheft || false}
              onChange={handleChange}
              name="ratetheft"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Theft"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratelegal || false}
              onChange={handleChange}
              name="ratelegal"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Legal AID"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratecsl || false}
              onChange={handleChange}
              name="ratecsl"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate CSL"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.rateroadside || false}
              onChange={handleChange}
              name="rateroadside"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Roadside"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.rateliabpd || false}
              onChange={handleChange}
              name="rateliabpd"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate LiabPD"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratepremiere || false}
              onChange={handleChange}
              name="ratepremiere"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Premiere"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.rateliabbi || false}
              onChange={handleChange}
              name="rateliabbi"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate LiabBI"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.rategap || false}
              onChange={handleChange}
              name="rategap"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate GAP"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ter_ext || false}
              onChange={handleChange}
              name="ter_ext"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Territorial Extension"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.ratecaravans || false}
              onChange={handleChange}
              name="ratecaravans"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Rate Caravans"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Agent Type"
          menuItems={agentTypes.map((type) => ({
            value: type.id,
            label: type.name,
          }))}
          value={form.agent_type_id || ""}
          name="agent_type_id"
          onChange={handleChange}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {buttonsSave()}
    </GridContainer>
  );
}
